/* index.js
 * Looks for embed codes on the page with class "simplestream-autoload" 
 * and initializes a Simplestream player instance.
 */

import BitmovinPlayer from './player.js';
import BitmovinMediaTailor from "./BitmovinMediaTailor";

(function(global) {

  let ssmp;
  let plugins = (document.currentScript.src.match(/[?&]plugins=([^&]+)/)?.[1]?.toLowerCase().split(',')) ?? [];

  function init() {
    initPlayers();
  }

  function initPlayers() {
    var players = document.getElementsByClassName('simplestream-autoload');
    for (var i = 0; i < players.length; ++i) {
        initPlayer(players[i].id, plugins);
    }
  }

  function initPlayer(playerId) {
      if(plugins.includes('mediatailor')){
          ssmp = new BitmovinMediaTailor(playerId, plugins);
      }else{
        ssmp = new BitmovinPlayer(playerId, plugins);
      }
  }

  function getPlayer(playerId) {
    return ssmp.get();
  }

  function destroyPlayer(playerId) {
    return ssmp.destroy();
  }

  function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {  // Only required for old IE
        script.onreadystatechange = function () {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  // Others
        script.onload = function () {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  global.simplestream = {
    init: init,
    initPlayer: initPlayer,
    getPlayer: getPlayer,
    destroyPlayer: destroyPlayer
  }

})(window);

document.addEventListener('DOMContentLoaded', function() {
  window.simplestream.init();
}, false);